/** @format */

import React from 'react'
import styled from 'styled-components'
import FormDesignable from 'src/components/FormDesignable'

interface ImportDialogProps {
  className?: string
}

const ImportDialog: React.FC<ImportDialogProps> = ({ className }) => {
  // const [visible, setVisible] = useState<boolean>(false)
  return <FormDesignable />
}

export default styled(ImportDialog)``
